<template>
  <!-- 账户流水 -->
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">账户资金流水</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">客户手机</div>
            <div class="query-inputs-div flex-1">
              <el-input size="small" v-model="queryInfo.mobile" placeholder="请输入内容" clearable @keyup.enter.native="getListData(pagination, true)"></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">类型</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" v-model="queryInfo.needDiscount" size="small" clearable>
                <el-option label="放电获得" value="01"></el-option>
                <el-option label="充电消费" value="02"></el-option>
                <el-option label="充值" value="03"></el-option>
                <el-option label="后台设置" value="04"></el-option>
                <el-option label="电卡兑换" value="05"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">起始日期</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                  v-model="searchTime"
                  style="width: 100%"
                  type="daterange"
                  size="small"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="handleDateChange"
              ></el-date-picker>
            </div>
          </div>
        </template>
        <template slot="actions">
          <div class>
            <button class="common-bg-button" @click="getListData(pagination, true)">搜 索</button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </div>
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
      </div>
    </div>
  </div>
</template>

<script>
  import pageConfig from './page-config';
  export default {
    data() {
      return {
        pageConfig,
        editFlag: false,
        queryInfo: {},
        pagination: pageConfig.pagination,
        tableData: [],
        searchTime: [], //注册时间
        operates: {
          width: 220,
          fixed: "right",
          list: [],
        }, // 列操作按钮
      }
    },
    methods: {
      init() {
        let _ = this;
        if (_.$store.state.editId) {
          _.editFlag = true;
          _.getListData();
        }
      },
      // 获取表单信息
      getListData() {
        let _ = this;
        // _.$S.getFormInfo(_, _.$A.pileType + '/' + _.$store.state.editId, function(res) {
        // });
      },

      // 选择注册时间
      handleDateChange(val) {
        if (val) {
          this.queryInfo.dtFrom = val[0];
          this.queryInfo.dtTo = val[1];
        } else {
          delete this.queryInfo.dtFrom;
          delete this.queryInfo.dtTo;
        }
      },

      //重置
      reset() {
        let _ = this;
        _.pagination.current = 1;
        _.searchTime = [];
        _.getListData(this.pagination, true);
      },
    },
    mounted() {
      this.init();
    }
  }
</script>

<style lang="less" scoped></style>
